// Loader.jsx
import React, { useEffect } from "react";
const Loader = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 700); // Adjusted loader duration to accommodate animations
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="fixed inset-0  flex items-center justify-center z-50">
      <img
        src="/img/icon.jpg"
        className="w-20 h-20 border-solid bg-white border-secondary-400 animate-pulse m-auto"
      />
    </div>
  );
};

export default Loader;
